module.exports = require("./az-Cyrl.js");